import { createTheme } from '@mui/material/styles'
export const theme = createTheme({
  palette: {
    primary: {
      main: '#2db47d',
      // Optional: MUI will automatically generate light/dark variants
      // You can override them if needed:
      light: '#5ce7a0',
      dark: '#145a4b',
      contrastText: '#ffffff',
    },
  },
})
export default theme
